import { BaseModel } from "paliari-js-utils"
import Pessoa from "./Pessoa"

const attributes = {
  id: null,
  login: "",
  email: "",
  nome: "",
  validado_por: "",
  matricula: null,
  codigo_fiscal: null,
  data_admissao: null,
  usuario_grupo_id: null,
  is_fisica: false,
  is_juridica: false,
  prefeitura: false,
  recebe_os: false,
  fiscal: false,
  cargo_id: null,
  cargo: obj => ({ ...obj }),
  perfis: obj => (obj ? [...obj] : []),
  pessoa: obj => new Pessoa(obj),
  assunto_ids: ids => (ids ? [...ids] : []),
  zona_ids: ids => (ids ? [...ids] : []),
}

class Usuario extends BaseModel {
  constructor(obj) {
    super(attributes, obj)
  }
}

export default Usuario
